import React, { useEffect, useRef, useState } from 'react';
import './portal.style.scss';
import { ReduxState, PortalPublish, PortalDetail } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { get } from 'scripts/api';
import { Spinner } from 'react-bootstrap';
import { kioskCode, portalData } from 'scripts/storage';
import { API } from 'data';
import { setPortalPublishData } from 'redux/actions';
import ucheckLogo from 'assets/images/logo/logo-white.png';
import useInterval from 'scripts/useInterval';
import SLPPhoneNumber from 'utilities/slp/phone/phone.index';
import SLPButton from 'utilities/slp/button/button.index';
import { emailValidation, urlValidation } from 'scripts/validation';
import useOnBlur from 'scripts/useOnBlur';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import PortalForm from './portalForm/portalForm.index';
import { offlinePortalKioskSubmit } from './portal.script';
import { newPortalToPortal } from 'ucheck/ucheck.scripts';

const PortalContainer: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const lang = props.lang.portal;
    const portalDetail = props.portalPublishData?.portal;
    const logoContainer = useRef<HTMLAnchorElement>(null);
    const logoutCounter = useRef(0);
    const [show, setShow] = useState(false);
    const [code, setCode] = useState('');
    const [activePublish, setActivePublish] = useState<string>();

    useInterval(() => {
        offlinePortalKioskSubmit();
        // offlinePortalKioskSubmit(undefined, portalDetail?.workspace);
    }, 60 * 1000);

    useInterval(() => {
        const code = kioskCode.get();
        if (code) {
            get<PortalDetail>(API.register.getPortalByCode(code)).then((res) => {
                const portal = newPortalToPortal(res.data);
                portalData.set(portal);
                props.dispatch(setPortalPublishData(portal));
            });
        }
    }, 2 * 60 * 1000);

    useEffect(() => {
        if (props.portalPublishData) {
            const checkKeys = (object: any) => {
                if (typeof object === 'object' && object !== null) {
                    for (let i = 0; i < Object.keys(object).length; i++) {
                        checkKeys(object[Object.keys(object)[i]]);
                    }
                } else if (Array.isArray(object)) {
                    for (let i = 0; i < object.length; i++) {
                        checkKeys(object[i]);
                    }
                } else if (urlValidation(object) && !emailValidation(object) && typeof object === 'string') {
                    const image = new Image();
                    image.src = object;
                }
            };
            checkKeys(props.portalPublishData);
        }
    }, [props.portalPublishData]);

    useOnBlur(logoContainer, () => {
        logoutCounter.current = 0;
    });

    const iconClick = () => {
        if (props.portalPublishData) {
            logoutCounter.current = logoutCounter.current + 1;
            if (logoutCounter.current === 10) {
                setShow(true);
            }
        }
    };

    if (activePublish) return <PortalForm onFinish={() => setActivePublish(undefined)} publish={activePublish} />;

    return (
        <div
            className="ucheck-kiosk-portal-slp-page"
            style={{ backgroundImage: `url(${portalDetail?.background_image_file?.file})` }}
        >
            <Modal
                onHide={() => setShow(false)}
                show={show}
                className={`ucheck-kiosk-logout-modal`}
                size={'lg'}
                centered
            >
                <div className="d-flex flex-column modal-container">
                    <i onClick={() => setShow(false)} className="material-icons close-icon">
                        close
                    </i>
                    <p>{lang.kioskLogout}</p>
                    <SLPPhoneNumber
                        value={code}
                        onChange={(e) => {
                            if (e !== undefined) setCode(e);
                        }}
                        placeholder=""
                    />
                    <SLPButton
                        onClick={() => {
                            if (Number(code) === kioskCode.get()) {
                                portalData.remove();
                                portalData.remove();
                                props.dispatch(setPortalPublishData(null));
                            } else toast.error(lang.wrongCodeErr);
                        }}
                    >
                        {lang.logout}
                    </SLPButton>
                </div>
            </Modal>
            {!portalDetail ? (
                <div className="loading">
                    <Spinner animation="border" />
                </div>
            ) : (
                <div className="content-portal">
                    <div className="header-portal">
                        {portalDetail.logo_file ? (
                            <img src={portalDetail.logo_file.file} alt={portalDetail.logo_file.alt} />
                        ) : null}
                        <h2>{portalDetail.title}</h2>
                        <h3>{portalDetail.description}</h3>
                    </div>
                    <div className="forms-list">
                        {portalDetail.publish_set.map((publish, index) => {
                            let image: string | null = null;
                            if (publish.form.logo_first_page_file?.file) {
                                image = publish.form.logo_first_page_file.file;
                            } else if (publish.form.first_page_bg_file?.file) {
                                image = publish.form.first_page_bg_file?.file;
                            } else if (publish.form.background_image_file?.file) {
                                image = publish.form.background_image_file?.file;
                            }
                            return (
                                <div
                                    key={index}
                                    className={`form-item ${
                                        Number(portalDetail.column_number) > 3 ? 'small-card' : ''
                                    }`}
                                    style={{
                                        width: `calc( ${
                                            100 / (portalDetail.column_number ? portalDetail.column_number : 3)
                                        }% - 20px )`,
                                    }}
                                >
                                    {image ? (
                                        <img src={image} alt={'logo'} />
                                    ) : (
                                        <div
                                            className="cover"
                                            style={{ backgroundColor: publish.form.background_color }}
                                        />
                                    )}
                                    <h3>{publish.form.title}</h3>
                                    <span className="UCheck-SLP-button" onClick={() => setActivePublish(publish.uuid)}>
                                        {lang.enter}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
            <div className="footer-portal">
                <a
                // target="_blank"
                // rel="noreferrer"
                // href="https://www.ucheck.me/?utm_source=slp&utm_medium=footer&utm_campaign=webslp"
                >
                    <img onClick={iconClick} src={ucheckLogo} alt="logo" />
                </a>
                {/* <div className="create-new-form">
                    <h4>{lang.createDesc}</h4>
                    <SLPButton href={RoutePath.panel} className="d-none d-md-flex">{lang.createForm}</SLPButton>
                    <i
                        onClick={() => window.open(UCheckPath.panel, '_blank')} className="ufi ufi-plus d-md-none"
                    />
                </div> */}
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
    portalPublishData: state.portalPublishData,
});

const connector = connect(mapStateToProps);
export default connector(PortalContainer);
